// extracted by mini-css-extract-plugin
module.exports = {"center":"document-list_center__1q2Ha","highlightedRow":"document-list_highlightedRow__9-1XY","unhighlightedRow":"document-list_unhighlightedRow__16T_t"};